import styled from 'styled-components';

export const Container = styled.div`
  position: relative;

  .banner-promo {
    &__link {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }

    &__img {
      display: block;
      width: 100%;
      max-width: 100%;
    }
  }
`;

export default Container;
